import React, { Fragment } from 'react'
import { UncontrolledTooltip } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import { DefaultConfig } from '../../settings/config'

export const userlistColumns = (functionCall) => {
    const formattedDateIssueFixed = DefaultConfig().formattedDateIssueFixed
    const DateConversion = DefaultConfig().DateConversion
    const columns = [
        {
            name: 'User Id',
            sortName: 'Id',
            sortable: true,
            cell: (row) => (
                <div style={{ cursor: 'pointer' }} onClick={() => { functionCall(row) }}>
                    {row.id}
                </div>
            ),
            sortable: true
        },
        {
            name: 'First Name',
            cell: (row) => {
                const targetId = `firstName-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word', cursor: 'pointer' }} id={targetId} className='rlmlinkshyperBlack'>
                            {row.firstName || '-'}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.firstName || '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: 'firstName',
            sortable: true
        },
        {
            name: 'Last Name',
            cell: (row) => {
                const targetId = `lastName-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word', cursor: 'pointer', color: "#000 !important" }} id={targetId} className='rlmlinkshyperBlack'>
                            {row.lastName || '-'}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.lastName || '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: 'lastName',
            sortable: true
        },
        {
            name: 'Email',
            cell: (row) => {
                const targetId = `email-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}
                            className='rlmlinkshyperBlack'>
                            {row.email || '-'}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.email || '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: 'email',
            sortable: true
        },
        {
            name: 'Status',
            cell: (row) => {
                const targetId = `status-${row.id}`
                const options = ["Active", "Inactive", "Suspended"]
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}>
                            {row.status ? options[row.status - 1] : '-'}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.status ? options[row.status - 1] : '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: 'status',
            sortable: true
        },
        {
            name: 'Last Modified By',
            cell: (row) => {
                const targetId = `modified-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}
                            className='rlmlinkshyperBlack'>
                            {row.lastModifiedBy || '-'}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.lastModifiedBy || '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: 'lastModifiedBy',
            sortable: true
        },
        {
            name: 'Last Modified Date',
            cell: (row) => {
                const targetId = `modifiedDate-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}
                            className='rlmlinkshyperBlack'>
                            {DateConversion(row.lastModifiedDate) || '-'}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {DateConversion(row.lastModifiedDate) || '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: 'lastModifiedDate',
            sortable: true
        }
    ]


    return columns
}
export const ActiveCompanies = (functionCall) => {
    const regionalOffices = DefaultConfig()?.regionalOffices
    const DepartmentMapping = DefaultConfig()?.DepartmentMapping
    const formattedDateIssueFixed = DefaultConfig().formattedDateIssueFixed
    const SourceSystemData = DefaultConfig().SourceSystem("options")
    const DiscountTypeLabel = (id) => SourceSystemData.find((type) => type.id === id)?.label || ''
    const DateConversion = DefaultConfig().DateConversion

    const columns = [
        {
            name: <div>Company ID</div>,
            width: "8%",
            sortName: "Id",
            sortable: true,
            cell: (row) => (
                <div style={{ cursor: 'pointer' }} onClick={() => { functionCall(row) }}>
                    {row.id}
                </div>
            )
        },

        {
            name: <div>Agent ID</div>,
            width: "8%",
            selector: row => {
                const targetId = `agentId-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}
                            className='rlmlinkshyperBlack'> {row.agentId ? row.agentId : '-'}</div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.agentId ? row.agentId : '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: "agentId",
            sortable: true
        },
        {
            name: <div>Company Name</div>,
            width: "18%",
            selector: row => {
                const targetId = `Name-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'> {row.name ? row.name : '-'}</div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.name ? row.name : '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: "name",
            sortable: true
        },
        {
            name: <div>SF Unique ID</div>,
            width: "8%",
            selector: row => {
                const targetId = `sfUniqueId-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'> {row.sfUniqueId ? row.sfUniqueId : '-'}</div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.sfUniqueId ? row.sfUniqueId : '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: "sfUniqueId",
            sortable: true
        },
        {
            name: <div>Regional Office</div>,
            width: "10%",
            selector: row => {
                const targetId = `email2-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'>
                            {row?.regionalOfficeIds?.map(entry => regionalOffices?.find(item => item?.id === entry)?.label)
                                .filter(Boolean)
                                .join(', ')}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row?.regionalOfficeIds?.map(entry => regionalOffices?.find(item => item?.id === entry)?.label)
                                .filter(Boolean)
                                .join(', ')}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: "sfUniqueId",
            sortable: true
        },
        {
            name: <div>GP Client Department</div>,
            width: "10%",
            selector: row => {
                const targetId = `email1-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'> {row.gpClientDepartmentId ? DepartmentMapping().find((item) => item.id === row.gpClientDepartmentId)?.label : '-'}</div>

                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.gpClientDepartmentId ? DepartmentMapping().find((item) => item.id === row.gpClientDepartmentId)?.label : '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: "gpClientDepartmentId",
            sortable: true
        },
        // {
        //     name: <div>Source System</div>,
        //     width: "9%",
        //     selector: row => {
        //         const targetId = `email-${row.id}`

        //         return (
        //             <Fragment>
        //                 <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'> {DiscountTypeLabel(row.sourceSystemId ? row.sourceSystemId : '-')}</div>

        //                 <UncontrolledTooltip placement='bottom' target={targetId}>
        //                 {row.sourceSystemLabel || '-'}
        //                 </UncontrolledTooltip>
        //             </Fragment>
        //         )
        //     },
        //     sortName: "gpClientDepartmentId",
        //     sortable: true
        // },
        {
            name: <div>Created Date</div>,
            width: "8%",
            selector: row => {
                const targetId = `email4-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'>  {row.createdDate ? formattedDateIssueFixed(row.createdDate) : "-"}</div>

                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.createdDate ? formattedDateIssueFixed(row.createdDate) : "-"}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: "createdDate",
            sortable: true
        },
        {
            name: <div>Status</div>,
            width: "8%",
            selector: row => {
                const targetId = `status-${row.id}`
                const options = ["Active", "Inactive", "Suspended"]
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} > {row.status ? options[row.status - 1] : ''}</div>
                        {/* <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.status ? row.status : '-'}
                        </UncontrolledTooltip> */}
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.status ? options[row.status - 1] : ''}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: "status",
            sortable: true
        },
        {
            name: <div>Last Modified By</div>,
            width: "10%",
            cell: (row) => {
                const targetId = `modified-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}
                            className='rlmlinkshyperBlack'>
                            {row.lastModifiedBy || '-'}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {row.lastModifiedBy || '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: 'lastModifiedBy',
            sortable: true
        },
        {
            name: <div>Last Modified Date</div>,
            width: "12%",
            cell: (row) => {
                const targetId = `modifiedDate-${row.id}`
                return (
                    <Fragment>
                        <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}
                            className='rlmlinkshyperBlack'>
                            {DateConversion(row.lastModifiedDate) || '-'}
                        </div>
                        <UncontrolledTooltip placement='bottom' target={targetId}>
                            {DateConversion(row.lastModifiedDate) || '-'}
                        </UncontrolledTooltip>
                    </Fragment>
                )
            },
            sortName: 'lastModifiedDate',
            sortable: true
        }
    ]
    return columns
}
